import styled from 'styled-components';
import ReactLoading from 'react-loading';

// Cores dinâmicas do tema (mesmas do ProfileForm)
const colors = {
  primary: '#122D58', // Azul escuro
  secondary: '#FFF28D', // Amarelo (mesma cor do botão Importar Múltiplos XMLs)
  lightBlue: '#4FC3F7', // Azul claro
  background: '#F5F5F5',
  white: '#FFFFFF',
  gray: '#E0E0E0',
  darkGray: '#666666',
  text: '#333333',
  success: '#4CAF50',
  error: '#F44336',
};

export const Container = styled.div`
  padding: 0;
  width: 100%;
  background-color: ${colors.background};
  min-height: 100vh;
`;

export const ModalContainer = styled.div`
  max-width: 1200px;
  margin: 20px auto;
  background: ${colors.white};
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
`;

export const ModalHeader = styled.div`
  background-color: ${colors.primary};
  color: ${colors.white};
  padding: 16px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ModalTitle = styled.h2`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: ${colors.white};
`;

export const HeaderButtons = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const HeaderSaveButton = styled.button`
  padding: 8px 20px;
  background-color: ${colors.secondary};
  color: ${colors.primary};
  border: none;
  border-radius: 3px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  
  &:hover {
    background-color: #FFEB3B;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(255, 242, 141, 0.3);
  }
`;

export const HeaderCancelButton = styled.button`
  padding: 8px 20px;
  background-color: transparent;
  color: ${colors.white};
  border: 1px solid ${colors.white};
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
`;

export const StepsContainer = styled.div`
  display: flex;
  background-color: ${colors.white};
  border-bottom: 1px solid ${colors.gray};
  padding: 0 24px;
`;

export const Step = styled.div`
  padding: 16px 24px;
  cursor: pointer;
  border-bottom: 3px solid transparent;
  transition: all 0.3s ease;
  color: ${props => props.active ? colors.primary : colors.darkGray};
  font-weight: ${props => props.active ? '600' : '400'};
  border-bottom-color: ${props => props.active ? colors.secondary : 'transparent'};
  background-color: ${props => props.active ? 'rgba(255, 242, 141, 0.1)' : 'transparent'};
  
  &:hover {
    background-color: ${props => props.active ? 'rgba(255, 242, 141, 0.1)' : 'rgba(0, 0, 0, 0.05)'};
  }
`;

export const StepNumber = styled.span`
  font-weight: 700;
  margin-right: 8px;
  color: ${props => props.active ? colors.primary : colors.darkGray};
`;

export const FormContent = styled.div`
  padding: 24px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  
  @media (max-width: 968px) {
    grid-template-columns: 1fr;
  }
`;

export const LeftPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const RightPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SectionTitle = styled.h3`
  font-size: 14px;
  font-weight: 700;
  color: ${colors.primary};
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const WrapperInput = styled.div`
  margin-bottom: 15px;
`;

export const AvatarSection = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 20px;
  background: ${colors.background};
  border-radius: 8px;
  margin-bottom: 20px;
`;

export const WrapperImage = styled.div`
  width: 109px;
  min-width: 109px;
  height: 109px;
  background: none;
  border: 1px solid ${colors.primary};
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Avatar = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 5px;
`;

export const ImageText = styled.p`
  font-size: 12px;
  color: ${colors.darkGray};
  margin-bottom: 10px;
`;

export const InputFile = styled.input`
  display: none;
`;

export const Loading = styled(ReactLoading).attrs({
  color: colors.primary,
})``;

export const ReactiveText = styled.p`
  font-size: 14px;
  color: ${colors.primary};
  text-align: center;
  padding: 16px;
  background-color: rgba(255, 242, 141, 0.1);
  border-radius: 4px;
  border: 1px solid ${colors.secondary};
`;

export const Error = styled.span`
  color: ${colors.error};
  font-size: 12px;
  margin-top: 5px;
  display: block;
`;

export const FullWidthSection = styled.div`
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
